'use strict';

var ngModule = 'frontend.directives';

require('angular')
  .module(ngModule, [ require('angular-sanitize') ])
  .directive('fileChange', require('./file'))
  .directive('cnMarkdown', require('./markdown'))
  .directive('cnPermission', require('./permission'));

module.exports = ngModule;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/directives/index.js
 ** module id = 18
 ** module chunks = 0
 **/